export default {
  title: "Factuur regels",

  input: {
    title: "Factuur regels bewerken",
    emptyLine: "Witregel",
    vat: "BTW:"
  },

  header: {
    line: "Tekst",
    price: "Prijs",
    vatPercent: "BTW%",
    vatTotal: "BTW",
    total: "Totaal",
  },

  footer: {
    total: "Totaal",
  },

  button: {
    addInvoiceLine: "Eenvoudige regel",
    addEmptyLine: "Witregel",
  },

  addLine: {
    require: {
      tax: "Onbekende standaard btw",
    },
  },
}
